export const styles = `
  .qt_infoBlock {
    position: relative;
    z-index: 10;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 6px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    transition-duration: 0.5s;
    transition-property: box-shadow, color, background-color;
  }

  .qt_infoContainer {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 3px;
    font-weight: bold;
  }

  .qt_altStacking {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .qt_behind {
    z-index: 5;
  }

  .qt_highlighted {
    box-shadow: 0 0 15px 15px white !important;
  }

  .qt_infoContainer:not(.qt_warnOff) .qt_warning {
    background-color: rgba(255, 42, 75, 0.55);
    color: white;
    animation: qt-warning-blink 1s infinite;
  }

  .qt_settingsCategoryLine {
    text-align: center;
    clear: both;
    padding: 8px 0 2px;
  }

  .qt_settingsCategoryTitle {
    clear: both;
    padding: 2px 0 10px;
    font-family: 'Merriweather', Georgia, serif;
    font-size: 15px;
  }

  @keyframes qt-warning-blink {
    0%, 100% {
      box-shadow: 0 0 5px 2px rgba(255, 42, 75, 0.9);
    }
    50% {
      box-shadow: 0 0 0 0 rgba(255, 42, 75, 0.9);
    }
  }
`;
